/*
 * View for a single task, assigned to a topic
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "moment",
  "modules/tasks/tasksModel",
  "./template/topicReviewTemplate.html",
  "./template/updateResponseTemplate.html",
  "./template/translateResponseTemplate.html",
  "./template/advancedTaskTemplate.html",
  "./template/taskAndStepTemplate.html",
], function (
  Marionette,
  $,
  Messenger,
  Moment,
  TaskModel,
  TopicReviewTemplate,
  UpdateResponseTemplate,
  TranslateResponseTemplate,
  AdvancedTaskTemplate,
  TaskAndStepTemplate,
) {
  "use strict";

  const TasksAreaView = {};

  //tooltip options.  Delays showing the tooltip for 1/3 of a second.
  const tooltipDelay = {
    show: 333,
    hide: 0,
  };

  // noinspection JSUnusedGlobalSymbols
  TasksAreaView.tasksAreaView = Marionette.Layout.extend({
    getTemplate: function () {
      switch (this.model.get("type")) {
        case TaskModel.TYPE.TOPIC_REVIEW:
          return TopicReviewTemplate;
        case TaskModel.TYPE.UPDATE_RESPONSE:
          return UpdateResponseTemplate;
        case TaskModel.TYPE.TRANSLATE_RESPONSE:
          return TranslateResponseTemplate;
        case TaskModel.TYPE.ADVANCED:
          return AdvancedTaskTemplate;
        case TaskModel.TYPE.TASK_AND_STEP:
          return TaskAndStepTemplate;
      }
    },
    onRender: function () {
      const _this = this;

      const dueDate = this.$el.find("#dueDate");
      const langCode = Messenger.reqres.request("get:interface:language");

      //get the format of the date to use by the datepickers
      const format = Messenger.reqres.request("get:datepicker:date:format");
      const dateToday = new Date();
      dueDate.datepicker({
        dateFormat: format,
        language: langCode,
        minDate: dateToday,
      });

      //Typeahead for users
      let userResults;
      const sourceFunction = function (query, process) {
        userResults = Messenger.reqres.request("usersWithId:typeahead", query);
        userResults.once(
          "sync",
          function () {
            process(
              userResults.map(function (result) {
                return result.get("text");
              }),
            );
          },
          this,
        );
      };

      this.$el.find("#txtUserSearch").typeahead(
        {
          source: sourceFunction,
          updater: function (item) {
            console.log("chose " + item);
            const userResult = userResults.findWhere({ text: item });
            if (userResult) {
              // Must wait, otherwise the closing of the typeahead will overwrite the value
              setTimeout(function () {
                _this.model.set("userId", userResult.get("id"));
                _this.model.set("user", userResult.get("text"));
                _this.$el.find("#txtUserSearch").val(userResult.get("text"));
              }, 100);
              return userResult.get("text");
            }
            _this.model.set("userId", 0);
            _this.model.set("user", "");
            _this.$el.find("#txtUserSearch").val("");
            return "";
          },
        },
        this,
      );

      //Standard stuff
      //internationalize the html
      this.$el.i18n();
      //apply tooltips
      this.$el.find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]').tooltip({
        delay: tooltipDelay,
        container: "body",
      });
      //apply textboxes defined in this.textboxes
      this._applyTextboxes();
    },
    textboxes: {
      "#taskDescription": {
        enableSelector: ["#taskDescriptionTitle", "#taskDescription"],
        modelAttribute: "description",
        placeholder: "task.description",
        textArea: true,
      },
    },
    triggers: {
      "click #reject": "reject:task",
      "click #startProgress": "start:progress:on:task",
      "click #approve": "approve:task",
      "click #complete": "complete:task",
      "click #ignore": "ignore:task",
      "click #resubmit": "resubmit:task",
      "click #deleteTask": "delete:task",
      "click #editTask": "edit:task",
      "click .btn-add-comment": "add:comment",
    },
    events: {
      "change #selTaskLanguage": function () {
        const optionSelected = this.$el.find("#selTaskLanguage option:selected").val();
        this.trigger("change:task:language", optionSelected);
      },
      "change #targetTaskLanguage": function () {
        const optionSelected = this.$el.find("#targetTaskLanguage option:selected").val();
        this.trigger("change:task:targetLanguage", optionSelected);
      },
      "change #selTaskTouchpoint": function () {
        const optionSelected = this.$el.find("#selTaskTouchpoint option:selected").val();
        this.trigger("change:task:touchpoint", optionSelected);
      },
      "change #txtUserSearch": function () {
        const user = this.$el.find("#txtUserSearch").val();
        // If the assigned user input was cleared, then set the user to unassigned
        if (user.length === 0) {
          this.trigger("change:task:user:unassigned");
        }
      },
      "change #dueDate": function () {
        const dueDate = this.$el.find("#dueDate").datepicker("getDate");
        const dueDateUtc = Messenger.reqres.request("to:dateUtc", dueDate);
        this.trigger("change:task:dueDate", dueDateUtc);
      },
    },
    modelEvents: {
      "validate:touchpoint:permission": function (permission) {
        if (permission) {
          this.$el.find("#userPermissionError").hide();
        } else {
          const errorMessage = $.t("task.noTouchpointPermission");
          this.$el
            .find("#userPermissionError")
            .html('<h5 class="error-message">' + errorMessage + "</h5>")
            .hide()
            .fadeIn();
        }
      },
    },
    regions: {
      schedule: ".task-schedule",
      steps: ".task-steps",
      uploads: ".task-uploads",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:dateUtc", date);
      },
      getStatusDisplay: function (statusId) {
        return Messenger.reqres.request("task:status:display", statusId);
      },
    },
  });

  return TasksAreaView;
});
